export const lockTabFocus = (element: HTMLElement) => {
  const handleTabKeyPress = (event: KeyboardEvent) => {
    const focusableElements = element.querySelectorAll<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    if (focusableElements.length === 0) {
      // If we encounter no elements to tab through, do nothing.
      event.preventDefault()
      return
    }

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (focusableElements.length === 1) {
      event.preventDefault()
      if (document.activeElement !== firstElement) {
        firstElement.focus()
      }
    }

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      }
    }
  }

  return handleTabKeyPress
}
